import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { useOrchestratorSteps } from '../../hooks/useOrchestratorSteps';
import {
  setSelectedProcess,
  getSelectedProcess,
} from '../../store/slices/domainOrchestratorPricingCommittee.slice';

export const ProcessFilterDropdown = () => {
  const dispatch = useDispatch();
  const selected = useSelector(getSelectedProcess);
  const { steps } = useOrchestratorSteps();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(setSelectedProcess(e.target.value));
  };

  return (
    <Form.Select
      className="h-100"
      data-testid="process-filter"
      style={{ fontSize: '14px' }}
      value={selected}
      onChange={handleChange}
    >
      <option value="">Seleccionar proceso</option>
      {steps.map(step => (
        <option key={step} value={step}>
          {step}
        </option>
      ))}
    </Form.Select>
  );
};
